import { validatePassword } from "./passwordValidation";

export default function PasswordRequirements({ password }) {

    const checks = validatePassword(password || "");

    const requirements = [
        { key: "minLength", label: "Mindestens 8 Zeichen" },
        { key: "hasNumber", label: "Mindestens 1 Zahl" },
        { key: "hasSpecialChar", label: "Mindestens 1 Sonderzeichen" },
        { key: "hasUpperCase", label: "Mindestens 1 Großbuchstabe" },
        { key: "hasLowerCase", label: "Mindestens 1 Kleinbuchstabe" },
    ];

    return (
        <ul style={{ fontSize: "0.8rem", margin: "0.25rem 0 0", paddingLeft: "1.2rem" }}>
            {requirements.map(({ key, label }) => (
                <li key={key} style={{ color: checks[key] ? "#005654" : "#d32f2f" }}>
                    {label}
                </li>
            ))}
        </ul>
    );
}